import type { ReactNode } from 'react';
import { landingListings, type Listing } from '../../core/layouts';
import { previewDestinations } from '../destinations';
import ListingVisibilityBadge from './ListingVisibilityBadge';
import { AI_DETECTOR_VISIBLE_FLAG, PLANNER_VISIBLE_FLAG, PROFILE_VISIBLE_FLAG } from '../analytics/client';
import type { PreviewLayoutProps } from './types';

/** The listings School Day and Lab Bench render, from the same props as the other layouts. */
export function listingsFromProps(props: PreviewLayoutProps): Listing[] {
  const d = previewDestinations(window.location.hostname);
  const { ideas = {} } = props;
  return landingListings({
    oneStepAhead: props.osaVisible, objectives: props.objectivesVisible, sites: props.sitesVisible,
    rubric: props.rubricVisible, marketplace: props.marketplaceVisible, collab: props.collabVisible,
    planner: props.plannerVisible, profile: props.profileVisible,
    writingFeedback: props.writingFeedbackVisible, aiDetector: props.aiDetectorVisible, jobs: props.jobsVisible,
    news: ideas.news?.visible,
  }, { ...d, jobs: props.jobsHref });
}

export const LISTING_ICONS: Record<string, string> = {
  'project-180': '🍎',
  one_step_ahead: '🪜', objectives: '✅', sites: '🧩', rubric: '🎯', collab: '🤝', planner: '🗓️',
  writing_feedback: '✍️', ai_detector: '🔍', jobs: '📍', marketplace: '🛍️', profile: '🪪', news: '🗞️',
};

export const STATUS_LABELS: Record<Listing['status'], string> = {
  open: 'Open today', in_development: 'In development', coming_soon: 'Coming soon', planned: 'Coming soon', idea: 'Just an idea',
};

/** Staff-only rollout details, with the same flag links the other layouts use. */
export function ListingStaffBadge({ id, props }: { id: string; props: PreviewLayoutProps }) {
  if (!props.showVisibilityDetails) return null;
  const ideas = props.ideas ?? {};
  const badges: Record<string, ReactNode> = {
    one_step_ahead: <ListingVisibilityBadge audience={props.osaAudience ?? 'unknown'} flagId={900567} />,
    sites: <ListingVisibilityBadge audience={props.sitesAudience ?? 'unknown'} flagId={888906} />,
    rubric: <ListingVisibilityBadge audience={props.rubricAudience ?? 'unknown'} flagId={894436} />,
    writing_feedback: <ListingVisibilityBadge audience={props.writingFeedbackAudience ?? 'unknown'} flagKey="preview-writing-feedback-visible" />,
    collab: <ListingVisibilityBadge audience={props.collabAudience ?? 'unknown'} flagId={905683} />,
    planner: <ListingVisibilityBadge audience={props.plannerAudience ?? 'unknown'} flagKey={PLANNER_VISIBLE_FLAG} />,
    jobs: <ListingVisibilityBadge audience={props.jobsAudience ?? 'unknown'} flagId={911638} />,
    marketplace: <ListingVisibilityBadge audience={props.marketplaceAudience ?? 'unknown'} flagId={896665} />,
    profile: <ListingVisibilityBadge audience={props.profileAudience ?? 'unknown'} flagKey={PROFILE_VISIBLE_FLAG} />,
    ai_detector: <ListingVisibilityBadge audience={props.aiDetectorAudience ?? 'unknown'} flagKey={AI_DETECTOR_VISIBLE_FLAG} />,
    news: <ListingVisibilityBadge audience={ideas.news?.audience ?? 'unknown'} flagId={911641} />,
  };
  return badges[id] ?? null;
}
